const START = '101100111000101';
const END = '110100011100101';

function checksum(hex: string) {
  let value = 0x5948;
  for (let index = 0; index < hex.length; index += 2) value = ((value << 5) - value + Number.parseInt(hex.slice(index, index + 2), 16)) & 0xffff;
  return value;
}

function uuidHex(value: string) {
  const compact = value.toLowerCase().replaceAll('-', '');
  if (!/^[0-9a-f]{32}$/.test(compact)) throw new Error('这张图纸暂时不能生成分享识别码');
  return compact;
}

function bitsForPatternId(patternId: string) {
  const hex = uuidHex(patternId);
  const payload = [...hex].map((value) => Number.parseInt(value, 16).toString(2).padStart(4, '0')).join('');
  return `${START}${payload}${checksum(hex).toString(2).padStart(16, '0')}${END}`;
}

export function drawShareCode(context: CanvasRenderingContext2D, patternId: string, right: number, top: number) {
  const bits = bitsForPatternId(patternId);
  const moduleWidth = 2;
  const height = 21;
  const width = bits.length * moduleWidth;
  const left = right - width;
  context.save();
  context.fillStyle = '#ffffff';
  context.fillRect(left - 8, top - 4, width + 16, height + 8);
  context.fillStyle = '#172033';
  [...bits].forEach((bit, index) => {
    if (bit === '1') context.fillRect(left + index * moduleWidth, top, moduleWidth, height);
  });
  context.restore();
}

function bitString(image: ImageData, y: number, startX: number, moduleWidth: number, modules: number) {
  let result = '';
  for (let module = 0; module < modules; module += 1) {
    const x = Math.min(image.width - 1, Math.max(0, Math.round(startX + (module + 0.5) * moduleWidth)));
    const index = (Math.min(image.height - 1, Math.max(0, y)) * image.width + x) * 4;
    const luminance = image.data[index] * 0.299 + image.data[index + 1] * 0.587 + image.data[index + 2] * 0.114;
    result += luminance < 110 ? '1' : '0';
  }
  return result;
}

function idFromBits(bits: string) {
  const start = bits.indexOf(START);
  if (start < 0) return '';
  const payloadStart = start + START.length;
  const payloadEnd = payloadStart + 128;
  const checksumEnd = payloadEnd + 16;
  if (bits.slice(checksumEnd, checksumEnd + END.length) !== END) return '';
  const payload = bits.slice(payloadStart, payloadEnd);
  const hex = Array.from({ length: 32 }, (_, index) => Number.parseInt(payload.slice(index * 4, index * 4 + 4), 2).toString(16)).join('');
  if (Number.parseInt(bits.slice(payloadEnd, checksumEnd), 2) !== checksum(hex)) return '';
  return `${hex.slice(0, 8)}-${hex.slice(8, 12)}-${hex.slice(12, 16)}-${hex.slice(16, 20)}-${hex.slice(20)}`;
}

export function decodeShareCode(image: ImageData) {
  const totalModules = START.length + 128 + 16 + END.length;
  const rowStart = Math.max(0, Math.floor(image.height * 0.015));
  const rowEnd = Math.min(image.height - 1, Math.ceil(image.height * 0.18));
  for (let y = rowStart; y <= rowEnd; y += Math.max(1, Math.floor(image.height / 220))) {
    for (let moduleWidth = 0.7; moduleWidth <= 6; moduleWidth += 0.1) {
      const codeWidth = totalModules * moduleWidth;
      const expectedLeft = image.width - 48 * (moduleWidth / 2) - codeWidth;
      for (let offset = -30; offset <= 30; offset += 2) {
        const id = idFromBits(bitString(image, y, expectedLeft + offset, moduleWidth, totalModules + 8));
        if (id) return id;
      }
    }
  }
  return '';
}
